import queryString from "query-string";
import {
  GetCreatorUserList,
  GetDate,
  GetIdsList, GetImprestStateList,
  GetSortField,
  GetSortType,
  GetTextSearch,
  GetUseHasAppendix
} from "../../../../../assets/convertUrlFilter";
import { OVERALL_COST_DETAIL } from "../../../../../constants/sectionTypes";
import {
  ALL_IMPREST_STATES_ARRAY,
  APPENDIX,
  CREATOR_USER_IDS,
  END_DATE, FILE_TYPE,
  IMPREST_IDS, IMPREST_STATES, IMPREST_STATES_FOR_OTHER_REPORTS,
  PAGE_NUM,
  ROUTES,
  SORT_FIELD,
  SORT_TYPE,
  START_DATE, TEAM_IDS,
  TEXT_SEARCH, USE_DETAIL, USER_IDS
} from "../../../../../constants/filters";
import {FILE_TYPES} from "../../../../../constants/file";

// const defaultFilter = {
//   file_type: "web",
//   end_date: '',
//   start_date: '',
//   sort_field: "amount",
//   sort_type: "desc",
//   routes: [],
//   text_search: "",
//   page_number: "",
//   use_detail:false
// };

export default () => {
  let filters = queryString.parse(document.location.search);
  return filtersNormalize(filters);
};

const filtersNormalize = filters => {
  return {
    [FILE_TYPE]: FILE_TYPES.WEB,
    [IMPREST_IDS]: GetIdsList(filters[IMPREST_IDS]),
    [START_DATE]: GetDate(filters[START_DATE]),
    [END_DATE]: GetDate(filters[END_DATE]),
    [APPENDIX]: GetUseHasAppendix(filters[APPENDIX]),
    [ROUTES]: filters[ROUTES]
        ? filters[ROUTES].split("~").map(item => {
          let par = item.split(".");
          let id = par[0];
          let type = par[1];
          return { id, type };
        })
        : [],
    [SORT_FIELD]: GetSortField(filters[SORT_FIELD], OVERALL_COST_DETAIL),
    [SORT_TYPE]: GetSortType(filters[SORT_TYPE]),
    [TEXT_SEARCH]: GetTextSearch(filters[TEXT_SEARCH]),
    [USE_DETAIL]: false,
    [USER_IDS]: GetIdsList(filters[USER_IDS]),
    [TEAM_IDS]: GetIdsList(filters[TEAM_IDS]),
    [IMPREST_STATES_FOR_OTHER_REPORTS]: GetImprestStateList(
        filters[IMPREST_STATES],
        ALL_IMPREST_STATES_ARRAY
    )
  };
};
